export { default } from "ember-stereo/-private/utils/resolve-urls";
